import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "../../../app/store";
import type { GetIncidentDetectionLapseReviewResponse } from "../../../api/incidentDetectionLapseReview";

import {
  fetchIncidentDetectionLapseReview,
  upsertIncidentDetectionLapseReview,
} from "./thunk";

export interface IncidentDetectionLapseReviewState {
  caseId?: string;
  status: "idle" | "loading" | "succeeded" | "failed";
  incidentDetectionLapseReview: GetIncidentDetectionLapseReviewResponse;
}

const initialState: IncidentDetectionLapseReviewState = {
  caseId: undefined,
  status: "idle",
  incidentDetectionLapseReview: {
    incident_detection_lapse_review: null,
  },
};

const incidentDetectionLapseReviewSlice = createSlice({
  name: "incidentDetectionLapseReview",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIncidentDetectionLapseReview.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchIncidentDetectionLapseReview.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.caseId = action.meta.arg;
        state.incidentDetectionLapseReview = action.payload;
      })
      .addCase(fetchIncidentDetectionLapseReview.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(upsertIncidentDetectionLapseReview.fulfilled, (state, action) => {
        state.incidentDetectionLapseReview.incident_detection_lapse_review = action.payload;
      });
  },
});

export const incidentDetectionLapseReviewReducer = incidentDetectionLapseReviewSlice.reducer;

export const selectIncidentDetectionLapseReview = (state: RootState) => state.incidentDetectionLapseReview.incidentDetectionLapseReview.incident_detection_lapse_review;

export const selectIncidentDetectionLapseReviewStatus = (state: RootState) => state.incidentDetectionLapseReview.status;
